import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Entities } from '../../../../core/models/globals';
import { HeaderService } from '../../../../core/services/header.service';
import { NavigationService } from '../../../../core/services/navigation.service';

@Component({
  selector: 'app-session-main-panel',
  templateUrl: './session-main-panel.component.html',
  styleUrls: ['./session-main-panel.component.scss']
})
export class SessionMainPanelComponent implements OnInit {

  lastRefreshedTime: Date; // time when data is loaded/refreshed

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navService: NavigationService,
    private headerService: HeaderService
  ) { }

  ngOnInit(): void {
    this.navService.subNavData(Entities.Sessions)
    this.navService.sendChildData(Entities.Sessions);
    this.navService.sendLastUpdate(this.headerService.getUserNewDate());
    this.navService.lastUpdateTime.subscribe(x => {
      this.lastRefreshedTime = x
    })
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

}
